import makeStyles from '@material-ui/core/styles/makeStyles';
import green from '@material-ui/core/colors/green';

const useStyle = makeStyles(theme => ({
  progressDialog: {
    width: 500,
    height: 280,
  },
  linearProgressRoot: {
    height: 10,
    borderRadius: 5,
  },
  linearProgresscolorPrimary: {
    backgroundColor: green[50],
  },
  linearProgressBar: {
    borderRadius: 5,
    backgroundColor: green[300],
    color: green[300],
  },
}));

export default useStyle;
